import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class MuCookieService {
  constructor(private cookies: CookieService) {
    /** */
  }

  /**
   *   method to get cookie according to name --- getCookie
   *   @param  {string} name Value to filter cookies in the navigator
   *   @return  {string}  Value of cookie filtered by name
   */

  getCookie(name: string) {
    return this.cookies.get(name);
  }

  /**
   *   method to set cookie according to name --- setCookie
   *   @param  {string} name Name to set cookie in the navigator
   *   @param  {string} value Value to set cookies in the navigator
   *   @param  {number} expires Time value of the cookie in the navigator
   *   @param  {string} expires Time value of the cookie in the navigator
   */

  setCookie(name: string, value: string, expires: number) {
    const days = expires / 60 / 60 / 24;
    this.cookies.set(name, value, { expires: days, path: '/' });
  }

  /**
   *   method to delete cookie according to name --- getCookie
   *   @param  {string} name Name to filter cookie in the navigator
   */

  deleteCookie(name: string) {
    this.cookies.delete(name, '/');
  }
}
